import { render } from "./user-group.vue?vue&type=template&id=16554f4c&ts=true"
import script from "./user-group.vue?vue&type=script&lang=ts"
export * from "./user-group.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__